import { action, observable } from 'mobx';
import React from 'react';

export interface IDownloadButtonProps {
    href: string;
    download?: any;
    createLink?: any;
    className?: string;
    disabled?: boolean;
    children?: React.ReactNode | string;
    useTarget?: boolean;// Set true if download button triggers beforeunload warning
}

export class DownloadButtonVM {
    @observable props: IDownloadButtonProps;
    constructor(props: IDownloadButtonProps) {
        this.props = props;
        
    }
    @action.bound downloadHandler(e) {
        e.preventDefault();      
        if(this.props.href !== "") {
          const link = document.createElement('a');
          link.href = this.props.href;
          link.download = this.props.download;
          if (this.props.useTarget) link.target = '_blank';
          link.click();
        }
    }
}